import gql from 'graphql-tag';

export const weddingDatePreferenceQuery = gql`
  query weddingDateComponentWeddingDatePreferences {
    weddingDatePreferences {
      datePreference
      hideDate
      season
      year
      weddingDate
      weddingDateFormat
      weddingDateRangeStart
      weddingDateRangeEnd
      hideCountdown
    }
  }
`;

export const eventsQuery = gql`
  query weddingDateComponentEventsQuery {
    events {
      id
      weddingId
      name
      type
      date
      time
      endTime
    }
  }
`;
